import { store } from '@state/redux/store';

export const isLoggedIn = (): boolean => {
  const state = store.getState();
  return !!state.users.user.attributes.email;
};
